import { CandybarItemConfigType, CandybarItemOptionType, CandybarItemType } from "../components/checkout/Candybar/types";

// @todo These methods are pretty similar and confusing... refactor needed.

export function getCandybarItemPriceWithSelectedOptions(item: CandybarItemType, unitConfig): number {
    return getCandybarItemPriceWithConfigsState(item, unitConfig);
}

export function getCandybarItemPriceWithConfigs(state, itemId, itemConfigs) {
    const item = state.entities.candybarItems[itemId];
    const isPaymentParam = Array.isArray(itemConfigs);
    let result = 0;

    if (isPaymentParam) {
        result += getCandybarItemPriceWithConfigsParam(item, itemConfigs);
    } else {
        result += getCandybarItemPriceWithConfigsState(item, itemConfigs);
    }

    return result;
}

function getCandybarItemPriceWithConfigsParam(item:CandybarItemType, itemConfigs) {
    let result = item.price;

    itemConfigs.forEach(unitConfig => {
        const config = findItemConfig(item, unitConfig.id);

        if (!config) {
            return;
        }

        config.options.forEach(option => {
            if (unitConfig.value.indexOf(option.id) > -1) {
                result += option.price;
            }
        });
    });

    return result;
}

function getCandybarItemPriceWithConfigsState(item:CandybarItemType, itemConfigs:Array<CandybarItemConfigType>) {
    let result = item.price;

    Object.keys(itemConfigs).forEach(unitConfigId => {
        if ('comments' === unitConfigId) {
            return;
        }

        const config = findItemConfig(item, unitConfigId);

        if (!config) {
            return;
        }

        config.options.forEach(option => {
            if (itemConfigs[unitConfigId].indexOf(option.id) > -1) {
                result += option.price;
            }
        })
    });

    return result;
}

function findItemConfig(item:CandybarItemType, configId:any): CandybarItemConfigType | null {
    configId = String(configId);

    const result = item.configs.reduce((carry:CandybarItemConfigType | null, config:CandybarItemConfigType) => {
        if (config.id === configId) {
            return config;
        }

        const subConfigs = config.options.reduce((carry:Array<CandybarItemConfigType>, option:CandybarItemOptionType) => carry.concat(option.subConfigs.filter(subConfig => subConfig.id === configId)), []);
        if (subConfigs.length) {
            return subConfigs[0];
        }

        return carry;
    }, null);

    return result;
}

export function getCandybarItemModifiersNames(product: CandybarItemType, selectedConfig: Record<string, string[]> | null = null): string | null {
    if (!product.configs || product.configs.length === 0) {
        return null;
    }

    if (!selectedConfig) {
        return product.configs.map(config => config.name).join(', ');
    }

    const modifierNames = product.configs.reduce((names: string[], config: CandybarItemConfigType) => {
        const selectedOptionIds = selectedConfig[config.id] || [];
        if (!selectedOptionIds) return names;

        const selectedOptions = config.options
            .filter((option: CandybarItemOptionType) => selectedOptionIds.includes(String(option.id)))
            .map((option: CandybarItemOptionType) => option.name);

        return names.concat(selectedOptions);
    }, []);

    return modifierNames.length > 0 ? modifierNames.join(', ') : null;
}

// Para la transacción, los configs ya vienen con nombres resueltos del backend
export function getCandybarTransactionModifiersArray(configs: any[]): string[] {
    if (!configs || !configs.length) return [];

    const modifiers: string[] = [];
    configs.forEach(config => {
        if (!config.options) return;
        config.options.forEach(option => {
            modifiers.push(`${config.name}: ${option.name}`);
            if (option.subConfigs) {
                option.subConfigs.forEach(subConfig => {
                    const subOptions = subConfig.options.map(o => o.name).join(', ');
                    modifiers.push(`${subConfig.name}: ${subOptions}`);
                });
            }
        });
    });

    return modifiers;
}

